export * from "./TriviaMedium";
